import Icon from 'components/Icon';
import Picture from 'components/Picture';
import Button from 'components/Button';

const TemplateItem = ({
  thumb,
  onClick,
  locale,
  title = 'WebDevLab',
  onImageChange,
}) => (
  <div className="col col-4 col-tablet-6 col-tablet-portrait-12">
    <div className="_mb-73">
      <div className="section__image-wrap _mb-15" onClick={onClick}>
        <Picture
          src={thumb}
          className="section__image"
          onError={onImageChange}
          onLoad={onImageChange}
        />
        <Button className="section__view-btn">View template</Button>
      </div>
      <div>
        {locale && (
          <Icon className="section__icon-flag" icon={`flag-${locale}`} />
        )}
        <h5 className="title title_size_xs_old section__title">{title}</h5>
      </div>
    </div>
  </div>
);

export default TemplateItem;

TemplateItem.defaultProps = {
  onImageChange: () => {},
};
